import React from 'react';
import { AlertCircle } from 'lucide-react';

// This component displays an error message box when data fails to load
const ErrorMessage = ({ message }) => {
  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6 flex items-start gap-3 dark:bg-red-900 dark:border-red-700">
      <AlertCircle className="text-red-500 flex-shrink-0 mt-0.5 dark:text-red-300" size={20} />
      <div>
        <h3 className="font-semibold text-red-900 mb-1 dark:text-red-200">
          Error Loading Repositories
        </h3>
        <p className="text-red-700 text-sm dark:text-red-200">{message}</p>
      </div>
    </div>
  );
};

export default ErrorMessage;